import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42a1402e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-r wording-edit" }
const _hoisted_2 = { class: "flex-div m-t-10 m-l-10" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("External Wording EN")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("External Wording CN")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"flex":"1"} }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "text-container",
  class: "text"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumb, { dataSource: [{name: 'Cover Page'}] }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_button, {
        class: "m-r-10 f-l m-b-10",
        type: _ctx.activeWording === 1 ? 'primary': 'default',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleWording(1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_component_a_button, {
        class: "f-l m-b-10",
        type: _ctx.activeWording === 2 ? 'primary' : 'default',
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleWording(2)))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["type"]),
      _hoisted_5,
      _createVNode(_component_a_button, {
        type: "primary",
        class: "m-r-10",
        onClick: _ctx.handleSaveWording
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", {
      id: "toolbar-container",
      class: _normalizeClass({'toolbar-fixed': _ctx.isFixed})
    }, null, 2),
    _hoisted_7
  ]))
}